import { Deferred } from "@/utils/Deferred";
import { ReservationState } from './model.roomsAndTotals';
export let globalModel: ReservationState | undefined;

export let modelDeferred = new Deferred<ReservationState>();
let modelLoader: ((signal: AbortSignal) => ReservationState | Promise<ReservationState>) | undefined;
let loadController: AbortController | undefined;

export function clearGlobalModel() {
    cancelGlobalModelLoad();
    modelLoader = undefined;
    globalModel = undefined;
    modelDeferred = new Deferred<ReservationState>();
}

export function setGlobalModelAsync(model: (signal: AbortSignal) => ReservationState | Promise<ReservationState>) {
    modelLoader = model;
    void retryGlobalModel().catch(() => {});
}

export function cancelGlobalModelLoad() {
    loadController?.abort();
}

export function retryGlobalModel(): Promise<ReservationState> {
    cancelGlobalModelLoad();
    if (!modelLoader) return modelDeferred.promise;
    const controller = loadController = new AbortController();
    const deferred = modelDeferred = new Deferred<ReservationState>();
    // A popup has one shared load, one deadline and no automatic retries.
    const timeout = setTimeout(() => controller.abort(), 60_000);
    const cancelled = () => deferred.reject(new Error('Reservation loading was cancelled or timed out. Please retry.'));
    controller.signal.addEventListener('abort', cancelled, { once: true });
    const loader = modelLoader;
    void Promise.resolve().then(() => loader(controller.signal)).then(model => {
        if (!controller.signal.aborted) deferred.resolve(model);
    }, error => deferred.reject(error));
    void deferred.promise.finally(() => {
        clearTimeout(timeout);
        controller.signal.removeEventListener('abort', cancelled);
    }).catch(() => {});
    // Pages can start loading before the React dialog subscribes.
    void deferred.promise.catch(() => {});
    return deferred.promise;
}

export function setGlobalModel(model: ReservationState) {
    if (!globalModel) {
        globalModel = model;
        modelDeferred = new Deferred<ReservationState>();
    }
    else {
        modelDeferred = new Deferred<ReservationState>();
    }
    modelDeferred.resolve(model);
}

export async function getGlobalModel(): Promise<ReservationState> {
    return modelDeferred.promise;
}
